/**
 * bundle-atc-fix.js
 * Corrige o bug onde o sticky ATC fica bloqueado após mudança de variante.
 *
 * Causa raiz: o toggleAddButton do tema só procura button[name="add"] DENTRO
 * do product-form-ID. O sticky ATC usa form="main_form_id" mas está FORA
 * desse elemento — por isso o tema nunca o reativa após mudança de variante.
 */
(function () {
  'use strict';

  function waitForPubSub(callback, tries) {
    tries = tries || 0;
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      callback();
    } else if (tries < 50) {
      setTimeout(function () { waitForPubSub(callback, tries + 1); }, 100);
    }
  }

  function init() {
    waitForPubSub(function () {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        var sectionId = event && event.data && event.data.sectionId;
        if (!variant || !sectionId) return;

        // Aguarda o tema terminar o fetch + toggleAddButton (~500ms)
        setTimeout(function () {
          // Todos os botões ATC desta secção que estão FORA do product-form
          // (sticky ATC usa form="product-form-ID" mas está fora do elemento)
          var allAtcBtns = document.querySelectorAll(
            'button[name="add"][form="product-form-' + sectionId + '"], ' +
            'button[name="add"][form="ProductForm-' + sectionId + '"], ' +
            '.main-product-atc[name="add"]'
          );

          // Botão dentro do form (o tema já trata deste, mas garantimos)
          var productForm = document.getElementById('product-form-' + sectionId);
          var mainBtn = productForm ? productForm.querySelector('button[name="add"]') : null;

          var isAvailable = variant.available;

          // Sincronizar todos os botões
          allAtcBtns.forEach(function (btn) {
            if (isAvailable) {
              btn.removeAttribute('disabled');
              btn.removeAttribute('aria-disabled');
              btn.setAttribute('data-unavailable', 'false');
            } else {
              btn.setAttribute('disabled', 'disabled');
              btn.setAttribute('data-unavailable', 'true');
            }
          });

          // Garantir botão principal também
          if (mainBtn) {
            if (isAvailable) {
              mainBtn.removeAttribute('disabled');
              mainBtn.removeAttribute('aria-disabled');
              mainBtn.setAttribute('data-unavailable', 'false');
            } else {
              mainBtn.setAttribute('disabled', 'disabled');
              mainBtn.setAttribute('data-unavailable', 'true');
            }
          }

        }, 600);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
